import { render, staticRenderFns } from "./PhilHealthEmployeeContribution.vue?vue&type=template&id=8b93f2d6"
import script from "./PhilHealthEmployeeContribution.vue?vue&type=script&lang=js"
export * from "./PhilHealthEmployeeContribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports